export default __webpack_public_path__ + "static/media/image-2.8a281a67.jpg";